<template>
  <b-container fluid>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div>
      <filtros-busqueda :empleados.sync="empleados"
                        @buscar="buscarDatosBMR" :tipo-busqueda="tipoBusqueda"/>
    </div>

    <hr/>
    <br/><br/>
    <div class="alert alert-primary"><h3>Bono de Referenciación Mensual</h3></div>
    <b-row>
      <b-col>
        <download-excel
            v-if="excel.length > 0"
            class="btn btn-primary"
            :data="excel"
            :fields="fieldsExcel"

            worksheet="My Worksheet"
            name="Bono de referencia.xls"
        >
          Generar Excel
          <em class="fa fa-file-excel-o"></em>
        </download-excel>
      </b-col>
    </b-row>
    <b-table
        id="Pendientes"
        thead-tr-class="columnas"
        :items="datosTabla"
        :fields="fields"
        :per-page="registrosPorPagina"
        :current-page="paginaActual"
        responsive
        stacked="md"
        class="parrafos"
        foot-clone
        no-footer-sorting
        foot-row-variant="secondary"
        show-empty>
      <template v-slot:cell(fechaSesion)="row">
        {{ row.item.fechaSesion | formatoFechaCorta }}
        --
        {{ row.item.fechaCalculoFechaProgramada | formatoFechaCorta }}
      </template>
      <template v-slot:cell(fechaPago)="row">
        {{ row.item.fechaPago | formatoFechaCorta }}
      </template>
      <template v-slot:cell(monto)="row">
        <span v-if="row.item.estabaRetenido" v-b-tooltip.hover title="'Comisión liberada'" class="text-primary" > {{ row.item.monto | moneda }}</span>
        <span v-else>{{ row.item.monto | moneda }}</span>
      </template>
      <template #foot()="row">
        {{ " " }}
      </template>
      <template #empty="scope">
        <b-col v-if="!loader">
          <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
        </b-col>
        <div align="center" v-if="loader">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
      </template>
      <template #foot(especialista)="row">
        Subtotal:
      </template>
      <template #foot(monto)="row">
        {{ subTotal | moneda }}
      </template>
    </b-table>

    <b-col v-if="!loader">
      <b-pagination
          v-if="datosTabla !== undefined && datosTabla.length > 15"
          align="center"
          v-model="paginaActual"
          :total-rows="datosTabla.length"
          :per-page="registrosPorPagina"
          aria-controls="my-table1"
      ></b-pagination>
    </b-col>



  </b-container>
</template>
<script>
import FiltrosBusqueda from "@/components/Compensaciones/FiltrosBusqueda";
export default {
  components: {FiltrosBusqueda},
  props: {
    empleados: Array
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      datosTabla: [],
      fields: [
        {key: "idComision", label: "ID", sortable: true},
        {key: "nombreDoctorComision", label: "Empleado", sortable: true},
        {key: "idTratamiento", label: "Num. Tx - Fecha Cálculo", sortable: true},
        {key: "idRecibo", label: "#Recibo", sortable: true},
        {key: "fechaSesion", label: "Fecha Tx", sortable: true},
        {key: "fechaPago", label: "Fecha Programada Pago", sortable: true},
        {key: "idPaciente", label: "ID Paciente", sortable: true},
        {key: "paciente", label: "Paciente", sortable: true},
        {key: "numeroSesion", label: "Sesión", sortable: true},
        {key: "tratamientio", label: "Tratamiento", sortable: true},
        {key: "clinica", label: "Clínica", sortable: true},
        {key: "diente", label: "OD", sortable: true},
        {key: "especialidad", label: "Especialidad", sortable: true},
        {key: "especialista", label: "Especialista", sortable: true},
        {key: "monto", label: "Bono", sortable: true}
      ],
      fieldsExcel: {
        "ID": "idComision",
        "Empleado": "nombreDoctorComision",
        "Num. Tx": "idTratamiento",
        "#Recibo": "idRecibo",
        "Fecha Tx": "fechaSesion",
        "Fecha Cálculo": "fechaCalculoFechaProgramada",
        "Fecha Programada Pago": "fechaPago",
        "ID Paciente": "idPaciente",
        "Paciente": "paciente",
        "Sesión": "numeroSesion",
        "Tratamiento": "tratamientio",
        "Clinica": "clinica",
        "OD": "diente",
        "Especialidad": "especialidad",
        "Especialista": "especialista",
        "Bono": "monto"
      },
      excel: [],
      registrosPorPagina: 15,
      paginaActual: 0,
      loader: false,
      subTotal: 0,
      tipoBusqueda: "mes"
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    buscarDatosBMR(filtros) {
      this.loader = true
      this.paginaActual=0;
      this.datosTabla = [];

      this.$http.post(this.$api + 'comisiones/comision/empleado/mensual', filtros).then(respuesta => {
            if (respuesta.data.data) {
              this.datosTabla = respuesta.data.data.tabla
              this.subTotal = respuesta.data.data.subTotal
              this.excel = JSON.parse(JSON.stringify(respuesta.data.data.tabla));
              this.excel.map(value => {
                value.fechaSesion =  this.$formatoFecha(value.fechaSesion);
                value.fechaPago =  this.$formatoFecha(value.fechaPago);
                value.fechaCalculoFechaProgramada = this.$formatoFecha(value.fechaCalculoFechaProgramada);
              })
            }
          }
      ).finally(() => {
            this.loader = false;
          }
      )
    }
  }
}
</script>
